export enum ChartKind {
  Bar = "bar",
  StackedBar = "stacked_bar",
  Line = "line",
  MultiLine = "multi_line",
  Pie = "pie",
  Gauge = "gauge"
}

// Display-type discriminators shared by chart and table renderers. Lives
// alongside ChartKind so utility modules (e.g. dreamerTableColumns) don't
// have to import from ChartMessage, which would create a circular cycle.
export enum ChartDisplayType {
  MONTH = "month",
  PERCENTAGE_0_TO_100 = "percentage_0_to_100"
}

const CHART_KINDS = new Set<string>(Object.values(ChartKind));

export const toChartKind = (display: string | undefined | null): ChartKind =>
  display && CHART_KINDS.has(display) ? (display as ChartKind) : ChartKind.Bar;

export const isChartKind = (v: unknown): v is ChartKind =>
  Object.values(ChartKind).includes(v as ChartKind);

// Re-export from the chart-primitive layer so existing import paths keep
// working while the canonical definition lives next to the chart components
// it serves (avoids upward dep from DreamerCharts → chat).
export { CHART_SEGMENT_COLORS } from "@/components/DreamerCharts/chartColors";
